module.exports = __webpack_public_path__ + "img/yandex-logo.c8c9f800.png";